module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-collapse', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tableData.length > 0),
      expression: "tableData.length > 0"
    }]
  }, [_c('el-collapse-item', {
    attrs: {
      "title": _vm.historyTitle
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.tableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "adjustmentDate",
      "label": _vm.dateLabel,
      "width": "110",
      "fixed": ""
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "comment",
      "label": _vm.commentLabel,
      "min-width": "200"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "siteSecurityClassification.name",
      "label": _vm.categoryLabel,
      "width": "100"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "riskLevel.name",
      "label": _vm.riskLevelLabel,
      "width": "100"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70bff3c0","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/history.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-70bff3c0","preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/history.vue
// module chunks = 0